import { useState } from "react";
import { Polygon } from "../elements/Polygon";
import MapPropertiesService from '../../services/MapPropertiesService';
import { useDarkmode } from 'components/hooks/useAppStore';


interface EvaluationFeaturePolygonProps {
    source: any
}
export const EvaluationFeaturePolygon = ({
    source
}: EvaluationFeaturePolygonProps) => {

    const mapProperties = MapPropertiesService.properties;
    const [fillOpacity, setFillOpacity] = useState(0.3);

    const darkmode = useDarkmode();
    const strokeColor = darkmode ? mapProperties.ColorFairwayAreaApplied: mapProperties.ColorFairwayAreaStroke;

    return (

        <Polygon
            paths={source.paths}
            fillColor={mapProperties.ColorFairwayAreaApplied}
            fillOpacity={fillOpacity}
            strokeColor={strokeColor}
            strokeWeight={2}
            strokeOpacity={0.8}
            zIndex={1}
            onMouseOver={onMouseOver}
            onMouseOut={onMouseOut}
        />
    );

    function onMouseOver() {
        setFillOpacity(0.6);
    }

    function onMouseOut() {
        setFillOpacity(0.3);
    }
}
